<div @loadingOverlay *ngIf="isLoading" class="w-full h-full flex flex-col space-y-4 items-center justify-center bg-gray-700">
    <img src="assets/mycatch/logo-vertical.png" />
    <svg-icon name="spinner" svgClass="animate-spin size-20 fill-white" />
</div>
<router-outlet (activate)="onActivate()"></router-outlet>